module.exports = "dist/a85ccf360fecc9e944dae3617f131577.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/materialicons.woff2
// module id = 198
// module chunks = 0